import React, { Component } from "react";
import "../css/PoliticaPrivacidade.css";
import { Link } from "react-router-dom";

export default class PoliticaPrivacidade extends Component {
    render() {
        const dataAtualizacao = "Abril de 2026";
        const nomeLoja = "Mega Veículos";
        const emailContato = "megaveiculosltda@hotmail.com";
        const telefoneContato = "(34) 99977-3435";

        return (
            <div className="politica-page">
                <header className="politica-header">
                    <Link to="/" className="politica-voltar">← Voltar</Link>
                    <h1>Política de Privacidade</h1>
                    <p>Atualizado em {dataAtualizacao}</p>
                </header>

                <main className="politica-container">
                    <div className="politica-section">
                        <h2>1. Quem somos</h2>
                        <p>
                            A <strong>{nomeLoja}</strong> é uma empresa especializada na
                            comercialização de veículos. Esta política descreve como
                            coletamos, usamos e protegemos os seus dados pessoais.
                        </p>
                    </div>

                    <div className="politica-section">
                        <h2>2. Dados que coletamos</h2>
                        <p>Podemos coletar as seguintes informações quando você entra em contato ou navega em nosso site:</p>
                        <ul>
                            <li>Nome completo</li>
                            <li>Telefone e e-mail</li>
                            <li>Preferências de veículos</li>
                            <li>Dados de navegação (cookies e acessos)</li>
                        </ul>
                    </div>

                    <div className="politica-section">
                        <h2>3. Como usamos seus dados</h2>
                        <p>Suas informações são utilizadas exclusivamente para:</p>
                        <ul>
                            <li>Entrar em contato para atendimento e negociação</li>
                            <li>Enviar ofertas de veículos de seu interesse</li>
                            <li>Melhorar a experiência de navegação no site</li>
                            <li>Cumprir obrigações legais</li>
                        </ul>
                    </div>

                    <div className="politica-section">
                        <h2>4. Compartilhamento de dados</h2>
                        <p>
                            Não vendemos nem compartilhamos seus dados com terceiros para fins
                            comerciais. Podemos compartilhar informações apenas quando exigido
                            por lei ou autoridades competentes.
                        </p>
                    </div>

                    <div className="politica-section">
                        <h2>5. Seus direitos</h2>
                        <p>De acordo com a LGPD (Lei nº 13.709/2018), você tem direito a:</p>
                        <ul>
                            <li>Acessar os dados que temos sobre você</li>
                            <li>Solicitar a correção ou exclusão dos seus dados</li>
                            <li>Revogar o consentimento a qualquer momento</li>
                            <li>Solicitar a portabilidade das informações</li>
                        </ul>
                    </div>

                    <div className="politica-section">
                        <h2>6. Contato</h2>
                        <p>Para dúvidas ou solicitações relacionadas à sua privacidade, entre em contato:</p>
                        <div className="politica-destaque">
                            <p>📧 {emailContato}</p>
                            <p>📞 {telefoneContato}</p>
                        </div>
                    </div>
                </main>

                <footer className="politica-footer">
                    <p>© {new Date().getFullYear()} {nomeLoja} — Todos os direitos reservados.</p>
                </footer>
            </div>
        );
    }
}